module.exports = __webpack_public_path__ + "static/img/3.6dfd691.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/3.jpg
// module id = 5xpk
// module chunks = 1